import { Box } from "@mui/material";
import styled from "styled-components";

export const ChartContainer = styled(Box)`
    min-width: 100%;
    height: 400px;
    position: relative;

    display: flex;
    gap: 4px;
    > .chart-loader{
        position: absolute;
        top: 50%;
        left: 50%;
    }

    /* Empty state responsive styles */
    .empty-state-container {
        width: 100% !important;
        min-width: 100% !important;
        
        @media (max-width: 768px) {
            padding: 20px 15px !important;
            min-height: 250px !important;
        }
        
        @media (max-width: 480px) {
            padding: 15px 10px !important;
            min-height: 200px !important;
        }
    }
    
    .empty-state-icon {
        @media (max-width: 768px) {
            width: 60px !important;
            height: 60px !important;
        }
        
        @media (max-width: 480px) {
            width: 50px !important;
            height: 50px !important;
        }
    }
    
    .empty-state-title {
        @media (max-width: 768px) {
            font-size: 1.1rem !important;
        }
        
        @media (max-width: 480px) {
            font-size: 1rem !important;
        }
    }
    
    .empty-state-description {
        @media (max-width: 768px) {
            font-size: 0.875rem !important;
            max-width: 250px !important;
        }
        
        @media (max-width: 480px) {
            font-size: 0.8rem !important;
            max-width: 200px !important;
        }
    }
`;

const styledComponents = { ChartContainer };
export default styledComponents;